import { PIECES } from '@blind-kings/game-core';
import BkPanel from '../../Components/ui/BkPanel';

const ROSTER = [
  PIECES.Peasant,
  PIECES.Assassin,
  PIECES.Knight,
  PIECES.Cavalry,
  PIECES.Mage,
  PIECES.Hero,
  PIECES.King,
] as const;

export default function PieceRoster() {
  return (
    <BkPanel className="overflow-hidden" padded={false}>
      <div className="border-b border-bk-gold-dim/30 px-4 py-3 sm:px-6">
        <p className="text-sm text-bk-muted sm:text-base">
          Each piece has a Combat Power (CP). In a normal fight, equal or higher CP wins.
        </p>
      </div>
      <ul className="flex gap-2 overflow-x-auto p-3 sm:grid sm:grid-cols-4 sm:gap-3 sm:overflow-visible sm:p-4 lg:grid-cols-7">
        {ROSTER.map((piece) => (
          <li
            key={piece.name}
            className="flex min-w-[5.5rem] flex-col items-center gap-1 rounded-sm border border-bk-border bg-bk-panel-raised px-2 py-3 text-center sm:min-w-0"
          >
            <span className="text-[10px] font-semibold uppercase tracking-wider text-bk-muted sm:text-xs">
              CP {piece.value}
            </span>
            <span className="text-sm font-bold uppercase tracking-wide text-bk-text sm:text-base">
              {piece.name}
            </span>
          </li>
        ))}
      </ul>
    </BkPanel>
  );
}
